import { defineComponent as _defineComponent } from 'vue'
import {
        onMounted, ref, unref, Ref,
    } from 'vue';
    import { Navigation } from 'swiper';
    import { SwiperCore, Swiper, SwiperSlide } from 'swiper-vue2';
    import { TrackJS } from 'trackjs';
    import {
        getSimilarHotels,
        SimilarHotel,
        ISimilarHotel,
    } from '@entities/hotel';

    import 'swiper/swiper.scss';
    import 'swiper/components/navigation/navigation.min.css';

    interface ISimilarHotelProps {
        hotelInfo: {
            category: number
            country: number
            id: number
        },
    }

    interface ISimilarHotelsEmits {
        (e: 'hide-skeletons'): void
    }

    
export default /*#__PURE__*/_defineComponent({
  __name: 'SimilarHotels',
  props: {
    hotelInfo: null
  },
  emits: ["hide-skeletons"],
  setup(__props: any, { emit }: { emit: ({
        (e: 'hide-skeletons'): void
    }), expose: any, slots: any, attrs: any }) {

const props = __props as {
        hotelInfo: {
            category: number
            country: number
            id: number
        },
    };

    SwiperCore.use([Navigation]);

    const similarHotels: Ref<ISimilarHotel[]> = ref([]);
    
    

    const swiperRef: Ref<InstanceType<typeof SwiperSlide> | null> = ref(null);

    const prev = () => unref(swiperRef)?.swiperRef.slidePrev();
    const next = () => unref(swiperRef)?.swiperRef.slideNext();

    const breakpoints = {
        768: {
            slidesPerView: 3,
            spaceBetween: 40,
        },
        1240: {
            slidesPerView: 4,
            spaceBetween: 40,
        },
        1440: {
            slidesPerView: 5,
            spaceBetween: 40,
        },
    };

    onMounted(async () => {
        try {
            const { data } = await getSimilarHotels(props.hotelInfo);
            similarHotels.value = data.result.filter((hotel) => hotel.id !== props.hotelInfo.id);

            emit('hide-skeletons');
        } catch (e: any) {
            TrackJS.track(e);
        }
    });

return { __sfc: true,similarHotels, props, emit, swiperRef, prev, next, breakpoints, Swiper, SwiperSlide, SimilarHotel }
}

})